import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { map } from 'ramda';

import Version from '../Version/Version';
import MainMenuListItem from './MainMenuListItem';

import cx from 'classnames';
import s from './MainMenu.css';


const MainMenuList = ({ activeItemKey,
                        accountEnabled,
                        closeMainMenu,
                        isUnauth,
                        items
}) => {
  return (
    <ul className={s.menuList}>
      {map(i =>
        i.visible &&
        <MainMenuListItem
          closeMainMenu={closeMainMenu}
          key={i.key}
          title={i.name}
          path={i.path}
          className={i.styleObject}
          isActive={activeItemKey === i.key}
        />,
        items
      )}

      <li className={cx(s.listItem, s.listItemBottom)}>
        {!isUnauth && accountEnabled &&
          <Link
            to="/account"
            id="Account"
            title="Account"
            className={cx(s.menuButton, s.account, (activeItemKey === 'account' ? s.active : ''))}
            onClick={closeMainMenu}
          >
            <p className={s.menuButtonText}>
              Account
            </p>
            <div className={s.iconCircle}>
              <div className={s.iconAccount}/>
            </div>
            <div className={s.arrowRight}/>
          </Link>
        }
        <Version/>
      </li>
    </ul>
  );
};

MainMenuList.propTypes = {
  closeMainMenu: PropTypes.func,
  items: PropTypes.array,
  activeItemKey: PropTypes.string,
};

export default MainMenuList;



// WEBPACK FOOTER //
// ./src/components/MainMenu/MainMenuList.js